import { render, staticRenderFns } from "./DiamondPricing.vue?vue&type=template&id=1fad0b60&scoped=true"
import script from "./DiamondPricing.vue?vue&type=script&lang=js"
export * from "./DiamondPricing.vue?vue&type=script&lang=js"
import style0 from "./DiamondPricing.vue?vue&type=style&index=0&id=1fad0b60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fad0b60",
  null
  
)

export default component.exports